module.exports = __webpack_public_path__ + "static/media/trek.8bf3d77f.png";